export const DEFAULT_PREVIOUS_INCOME_MONTHS_AT = 6;
